export const imageUrl = (name: string) =>
  "https://api.lifeofmarrow.com/images?img=" + name;
// (process.env.NODE_ENV === "production"
//     ? "https://api.lifeofmarrow.com/images?img="
//     : "http://localhost:4000/images?img=")
    //

// export const localImageUrl = (url: string) => `http://localhost:3000${url}`;
export const localImageUrl = (url: string) => `https://lifeofmarrow.com${url}`;
